<template>
  <div class="editor">
    <content-tab-bar :tabs="tabs" :selectedTab.sync="selectedTab" :links="false"></content-tab-bar>
    <alert-details
      v-if="selectedTab === 'Summary'" :alert="alert" :related="alert.parsed.related">
    </alert-details>
    <alert-related-processes
      v-else-if="selectedTab.startsWith('Processes')"
      :processes="alert.parsed.related.processes"
      :related="alert.parsed.related">
    </alert-related-processes>
    <alert-related-files
      v-else-if="selectedTab.startsWith('Files')"
      :files="alert.parsed.related.files"
      :related="alert.parsed.related">
    </alert-related-files>
    <alert-related-binaries
      v-else-if="selectedTab.startsWith('Binaries')"
      :binaries="alert.parsed.related.binaries"
      :related="alert.parsed.related">
    </alert-related-binaries>
    <alert-related-groups
      v-else-if="selectedTab.startsWith('Groups')"
      :groups="alert.parsed.related.groups"
      :related="alert.parsed.related">
    </alert-related-groups>
    <alert-related-users
      v-else-if="selectedTab.startsWith('Users')"
      :users="alert.parsed.related.users"
      :related="alert.parsed.related">
    </alert-related-users>
    <alert-json v-else-if="selectedTab === 'Json'" :data="alert.alert">
    </alert-json>
  </div>
</template>

<script>
import ContentTabBar from '@/components/ContentTabBar.vue';
import AlertDetails from '@/views/alerts/tabs/AlertDetails.vue';
import AlertRelatedProcesses from '@/views/alerts/tabs/AlertRelatedProcesses.vue';
import AlertRelatedFiles from '@/views/alerts/tabs/AlertRelatedFiles.vue';
import AlertRelatedBinaries from '@/views/alerts/tabs/AlertRelatedBinaries.vue';
import AlertRelatedUsers from '@/views/alerts/tabs/AlertRelatedUsers.vue';
import AlertRelatedGroups from '@/views/alerts/tabs/AlertRelatedGroups.vue';
import AlertJson from '@/views/alerts/tabs/AlertJson.vue';

export default {
  name: 'Alert',
  components: {
    AlertDetails,
    AlertJson,
    ContentTabBar,
    AlertRelatedProcesses,
    AlertRelatedFiles,
    AlertRelatedBinaries,
    AlertRelatedGroups,
    AlertRelatedUsers,
  },
  props: {
    alert: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTab: 'Summary',
    };
  },
  computed: {
    // Currently not using the ContentTabBar or router links but keeping that info here if needed
    tabs() {
      return [
        {
          label: 'Summary',
          tab: 'Summary',
          icon: 'summary',
        },
        {
          label: `Processes (${this.alert.parsed.related.processes.length})`,
          icon: 'process_circle',
        },
        {
          label: `Files (${this.alert.parsed.related.files.length})`,
          icon: 'file_circle',
        },
        {
          label: `Binaries (${this.alert.parsed.related.binaries.length})`,
          icon: 'binary_circle',
        },
        {
          label: `Users (${this.alert.parsed.related.users.length})`,
          icon: 'user',
        },
        {
          label: `Groups (${this.alert.parsed.related.groups.length})`,
          icon: 'group',
        },
        {
          label: 'Json',
          icon: 'json',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.editor {
  width: 100%;
  height: 100%;
}
</style>
